import React, { useEffect, useRef } from 'react';
import { components, GroupBase, MenuListProps } from 'react-select';
import styles from './styles.module.scss';

type Props = MenuListProps<unknown, boolean, GroupBase<unknown>> & {
  page: number;
  totalPages: number;
  loadMore: (scrollTop: number) => void;
  menuScrollTop: number;
};

export const MenuList = ({
  page,
  totalPages,
  loadMore,
  menuScrollTop,
  children,
  ...props
}: Props) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const childrenCount = React.Children.count(children);

  // optionsが変化したあとにスクロールを戻す。
  // childrenCount を trigger として使用し、options 更新後に menuScrollTop へスクロールを復元する。
  // menuScrollTop は effect 内で参照しているが deps から外している。理由: options 更新後のタイミング
  // でのみ発火させる意図のため（menuScrollTop 単体変化で発火すると動作が変わる）。
  // biome-ignore lint/correctness/useExhaustiveDependencies: menuScrollTop を deps から除外するのは意図的（上記コメント参照）
  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.scrollTop = menuScrollTop;
    }
  }, [childrenCount]);

  const handleLoadMore = () => {
    if (menuRef.current) {
      loadMore(menuRef.current.scrollTop);
    }
  };

  return (
    <components.MenuList {...props} innerRef={menuRef}>
      {children}
      {page < totalPages && (
        <div className={styles.loadMoreButton} onClick={handleLoadMore}>
          もっと見る
        </div>
      )}
    </components.MenuList>
  );
};
